import { render, staticRenderFns } from "./goodsconfirm-add.vue?vue&type=template&id=650bec8c"
import script from "./goodsconfirm-add.vue?vue&type=script&lang=js"
export * from "./goodsconfirm-add.vue?vue&type=script&lang=js"
import style0 from "./goodsconfirm-add.vue?vue&type=style&index=0&id=650bec8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports